import { Link } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import '../Home/Home.css';
import './Help.css';

const ARTICLES = [
    {
        id: 'balance',
        link: { to: '/wallet' },
    },
    {
        id: 'order',
        link: { to: '/activity' },
    },
    {
        id: 'voucher',
        link: { to: '/vouchers' },
    },
];

function HelpPage() {
    const { t } = useTranslation('help');
    return (
        <div className="help-page">
            <div className="page-heading">
                <div>
                    <h1>{t('heading.title')}</h1>
                    <p>{t('heading.subtitle')}</p>
                </div>
            </div>

            <div className="help-page__list">
                {ARTICLES.map((article) => (
                    <section className="panel" key={article.id}>
                        <div className="section-head">
                            <h2>{t(`articles.${article.id}.title`)}</h2>
                        </div>
                        {article.id === 'balance' ? (
                            <div className="help-page__notice">
                                {t(`articles.${article.id}.notice`)}
                            </div>
                        ) : null}
                        <p className="help-page__body">{t(`articles.${article.id}.body`)}</p>
                        <Link className="text-button" to={article.link.to}>
                            {t(`articles.${article.id}.link`)}
                            <RightOutlined />
                        </Link>
                    </section>
                ))}
            </div>
        </div>
    );
}

export default HelpPage;
